import { datadogLogs as _datadogLogs } from '@datadog/browser-logs';

import { useInitializeDatadog } from '@/utils/datadog/useInitializeDatadog';

import { DatadogContext } from './DatadogContext';

export type DatadogContextType = {
  datadogLogs: typeof _datadogLogs | undefined;
};

export const DatadogContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { datadogLogs } = useInitializeDatadog();
  return (
    <DatadogContext.Provider value={{ datadogLogs }}>
      {children}
    </DatadogContext.Provider>
  );
};
